module.exports = __webpack_public_path__ + "img/topicList.3cbbfd7d.jpg";